import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { api, ApiError } from '../../lib/api.js';
import { Spinner } from '../ui/Spinner.js';

/**
 * AdminRoute — verifies the current user has admin access by calling
 * /api/admin/internal-users (which requires a valid CF Access JWT +
 * presence in the internal_users table).
 *
 * In production, Cloudflare Access will redirect unauthenticated users
 * to the Access login page before reaching this component. This guard
 * is a second layer for the application-level allowlist check.
 */
export function AdminRoute() {
  const [status, setStatus] = useState<'loading' | 'authorised' | 'forbidden'>('loading');

  useEffect(() => {
    api
      .get('/api/admin/internal-users')
      .then(() => setStatus('authorised'))
      .catch((err) => {
        if (err instanceof ApiError && err.status === 403) {
          setStatus('forbidden');
        } else {
          // Other errors (network, etc.) — treat as forbidden for safety
          setStatus('forbidden');
        }
      });
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center bg-neutral-950">
        <Spinner size="lg" />
      </div>
    );
  }

  if (status === 'forbidden') {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return <Outlet />;
}
